import { render, staticRenderFns } from "./PromotionPlanValueTiers.vue?vue&type=template&id=00cef40c&"
import script from "./PromotionPlanValueTiers.vue?vue&type=script&lang=js&"
export * from "./PromotionPlanValueTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports